import FilterPanel from './filterPanel.container';

export default FilterPanel;